var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_vm._v(" 分享成功1222222222222222222222222222 ")])
}
var staticRenderFns = []

export { render, staticRenderFns }